export class ListAccordion {
  constructor() {
    this.elements = [...document.querySelectorAll(`.li--item`)];
    this.init();
  }

  bindClick = () => {
    this.elements.forEach((element) => {
      element.addEventListener(`click`, function () {
        const item = this.querySelector(`.li--content`);
        const div = this.querySelector(`.li--show`);
        const left = div.querySelector(`.show--img-left`);
        const right = div.querySelector(`.show--img`);
        if (this.classList.contains(`item--active`)) {
          this.classList.remove(`item--active`);
          if (right.classList.contains(`hidden`)) {
            right.classList.remove(`hidden`);
          }
          left.classList.add(`hidden`);
        } else {
          this.classList.add(`item--active`);
          if (left.classList.contains(`hidden`)) {
            left.classList.remove(`hidden`);
          }
          right.classList.add(`hidden`);
        }
        if (item.style.maxHeight) {
          item.style.maxHeight = null;
        } else {
          item.style.maxHeight = item.scrollHeight + "px";
        }
      });
    });
  };

  init = () => {
    this.bindClick();
  };
}
